import axios, { AxiosInstance } from 'axios';
import { UfcShopTokenUtils } from '../../../skeleton/env/ufc-shop-token-store';

// 创建 axios 实例
const service: AxiosInstance = axios.create({
  baseURL: 'https://api.dtc.test.unionfab.com',
  // process.env.NEXT_PUBLIC_MESSAGE_ENDPOINT ||
  // window.gConfig.MESSAGE_ENDPOINT ||
  // (process.env.NODE_ENV === 'production'
  //   ? 'https://api.dtc.unionfab.com'
  //   : 'https://api.dtc.test.unionfab.com'),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
  },
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = UfcShopTokenUtils.getAccessToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    const { data } = error.response;
    return Promise.reject({
      statusCode: error.response.status,
      LogCode: data.code,
      LogResponse: JSON.stringify(data),
    });
  },
);

export function get<T = any>(url: string, params?: any): Promise<T> {
  return service.get(url, { params });
}

export function post<T = any>(url: string, data?: any): Promise<T> {
  return service.post(url, data);
}

export function put<T = any>(url: string, data?: any): Promise<T> {
  return service.put(url, data);
}

export function del<T = any>(url: string, params?: any): Promise<T> {
  return service.delete(url, { params });
}

export default service;
